import UpsellCard from "./UpsellCard";
import React from "react";
import PremiumIcon from "../../icons/products/premium.svg";
import WooIcon from "../../icons/products/woo.svg";
import AIPlus from "../../icons/products/ai_plus.svg";
import DocsIcon from "../../icons/products/docs_addon.svg";

const pluginUpsellId = "plugin.upsell";
const pluginUpsellProps = [
	{
		icon: PremiumIcon,
		description: {
			id: "premium.description",
			defaultMessage: "Automate your technical SEO and optimize for local, video, and news SEO",
		},
		link: {
			name: "Yoast SEO Premium",
			url: "https://yoast.com/wordpress/plugins/seo/",
		},
	},
	{
		icon: WooIcon,
		description: {
			id: "woocommerce.description",
			defaultMessage: "Everything in Yoast SEO Premium + WooCommerce SEO for your store",
		},
		link: {
			name: "WooCommerce SEO",
			url: "https://yoast.com/wordpress/plugins/yoast-woocommerce-seo/",
		},
	},
	{
		icon: AIPlus,
		description: {
			id: "aiplus.description",
			defaultMessage: "The complete toolkit to monitor, measure, and improve your brand’s visibility " +
				"across both search engines and AI platforms like ChatGPT.",
		},
		link: {
			name: "Yoast AI+",
			url: "https://yoast.com/product/yoast-seo-ai-plus/",
		},
	},
	{
		icon: DocsIcon,
		description: {
			id: "docs.description",
			defaultMessage: "Yoast SEO Readability, SEO, and Inclusivity Analyses in Google Docs",
		},
		link: {
			name: "Docs Add-on",
			url: "https://yoast.com/product/google-docs-addon/",
		},
	},
];

/**
 * PluginUpsell component.
 * @returns {JSX.Element} Upsell card.
 */
const PluginUpsell = () => {
	return (
		<UpsellCard
			id={ pluginUpsellId }
			header={ {
				id: "header",
				defaultMessage: "Outrank your competitors with Yoast extensions",
			} }
			listPropsArray={ pluginUpsellProps }
		/>
	);
};

export default PluginUpsell;
